/**
 * ATTENTION: This file is auto generated by using "prepareTemplates".
 * Do not change the content!
 *
 */

/**
 * Library Index avatar to autogenerate all the components and extensions
 * Used by "prepareAvatars"
 */

import Avatar from './avatar/Avatar'
export * from './avatar/Avatar'
export default Avatar
